import apiValidation from '../validation/ApiRespValidation'

const selectMapper = (data) => {
    try {
        let responseMapper = [];
        for (var i = 0; i < data.length; i++) {
            responseMapper[i] = {
                nemonico: data[i].nemonico ?? '',
                nombre: data[i].nombre ?? ''
            }
            responseMapper.push();
        }

        const response = {
            "error": false,
            "variant": "success",
            "data": responseMapper
        }

        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const selectMarcaModelMaterMapper = (data) => {
    try {

        let responseMarcaMapper = [];
        for (var i = 0; i < data.dataMarca.length; i++) {
            responseMarcaMapper[i] = {
                nemonico: data.dataMarca[i].nemonico ?? '',
                nombre: data.dataMarca[i].nombre ?? ''
            }
            responseMarcaMapper.push();
        }

        let responseModelMapper = [];
        for (var i = 0; i < data.dataModel.length; i++) {
            responseModelMapper[i] = {
                nemonico: data.dataModel[i].nemonico ?? '',
                nombre: data.dataModel[i].nombre ?? ''
            }
            responseModelMapper.push();
        }

        let responseMaterialesMapper = [];
        for (var i = 0; i < data.dataMateriales.length; i++) {
            responseMaterialesMapper[i] = {
                nemonico: data.dataMateriales[i].nemonico ?? '',
                nombre: data.dataMateriales[i].nombre ?? ''
            }
            responseMaterialesMapper.push();
        }

        const response = {
            "error": false,
            "variant": "success",
            "dataMarca": responseMarcaMapper,
            "dataModel": responseModelMapper,
            "dataMateriales": responseMaterialesMapper
        }

        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    selectMapper,
    selectMarcaModelMaterMapper
}
